module.exports = __webpack_public_path__ + "static/media/Bannertech.2e86d148.png";